import { render, staticRenderFns } from "./DownloadExcel.vue?vue&type=template&id=24bd8ad7"
import script from "./DownloadExcel.vue?vue&type=script&lang=js"
export * from "./DownloadExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports